'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactSlidedown = require('react-slidedown');

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _ComcastPetitionLanding = require('./ComcastPetitionLanding.css');

var _ComcastPetitionLanding2 = _interopRequireDefault(_ComcastPetitionLanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComcastPetitionLanding = (_dec = (0, _reactCssModules2.default)(_ComcastPetitionLanding2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ComcastPetitionLanding, _Component);

  function ComcastPetitionLanding(props) {
    (0, _classCallCheck3.default)(this, ComcastPetitionLanding);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComcastPetitionLanding.__proto__ || (0, _getPrototypeOf2.default)(ComcastPetitionLanding)).call(this, props));

    _this.state = {
      title: 'Comcast: Stop Investing Employee Savings into Prisons',
      description: 'Join As You Sow to urge Comcast management to offer a prison-free default retirement fund.',
      url: _config2.default.domain + _config2.default.routes.comcastPetitionLanding,
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    };
    return _this;
  }

  (0, _createClass3.default)(ComcastPetitionLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          title = _state.title,
          description = _state.description,
          url = _state.url;


      var headlineImg = require('../../../static/images/handsbars-circle.jpg');

      var mobileBannerStyle = this.state.mobileBannerFixed ? 'mobile-fixed' : 'mobile-relative';

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'hl-wrap' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'hl' },
                title
              ),
              _react2.default.createElement('img', {
                src: headlineImg,
                alt: 'Comcast: Stop Investing Employee Savings into Prisons',
                styleName: 'hl-img-sm visible-xs'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Comcast is currently investing its employees\u2019 savings into companies profiting from the prison industrial complex \u2013 which includes for-profit prisons, companies profiting from exploitative prison labor, and immigration jails.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Comcast has made public commitments to help address structural racism, including a $100 million plan to fight injustice and inequality. But most employees at Comcast have no idea that their retirement plan is invested in companies involved in mass incarceration, immigrant policing and surveillance, or the border industry.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'These firms are known to lobby for harsher policing and sentencing of non-violent crimes that impact poor communities, immigrants, and people of color. If this isn\'t your idea of how Comcast employees should invest their hard-earned money, you can join thousands of other concerned citizens to call on Comcast to help direct investments away from the prison and border industries.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Join As You Sow to urge Comcast management to live up to their public commitments by offering a prison-free default retirement fund.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'hidden-xs' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Mass incarceration is a manifestation of racist policy. Companies like Comcast that have the prison industrial complex embedded in their 401(k) plans are forcing their employees to invest in racial injustice. It\u2019s time for employees and society at large to make sure that investments stop funding private prisons and other companies profiting from economic systems of oppression and exploitation.'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'scroll-link' },
                    _react2.default.createElement(
                      _reactScroll.Link,
                      {
                        activeClass: 'active-scroll-link',
                        to: 'section1',
                        spy: true,
                        smooth: true,
                        offset: -70,
                        duration: 500
                      },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Start by signing this petition to Comcast\u2019s management saying that it\u2019s time to stop funding the prison industrial complex.'
                      )
                    )
                  ),
                  _react2.default.createElement(_components.ComcastPetitionLetter, null)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links hidden-xs' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-lbl' },
                    'More'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans + '/comcast',
                        title: 'Comcast 401(k) scorecard',
                        xstrong: true
                      },
                      'See the scorecard for the Comcast 401(k)',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenter,
                        title: 'Action center',
                        xstrong: true
                      },
                      'Action center',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hl-img-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'petition-widget-wrap' },
                _react2.default.createElement('img', {
                  src: headlineImg,
                  alt: 'Comcast: Stop Investing Employee Savings into Prisons',
                  styleName: 'hl-img hidden-xs'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sticky-widget ' + mobileBannerStyle },
                  _react2.default.createElement('div', { id: 'section1' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sticky-widget-close visible-xs' },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: function onClick() {
                          //
                          _this2.setState({
                            mobileBannerFixed: false
                          });
                        }
                      },
                      _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-close' })
                    )
                  ),
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'thumbs-up-top-label' },
                    'Comcast: Stop Investing Employee Savings into Prisons'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'c' },
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'thumbs-up-top-label-2' },
                      'Sign this petition'
                    )
                  ),
                  _react2.default.createElement(_components.PetitionForm, {
                    petitionConfig: _config2.default.petitionConfigs.comcast
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'show-more-button',
                title: 'Learn more',
                onClick: function onClick(e) {
                  _this2.setState({ showFullPetition: !_this2.state.showFullPetition });
                }
              },
              'Learn more',
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.showFullPetition ? 'fa-angle-double-up' : 'fa-angle-double-down' })
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              this.state.showFullPetition ? _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Mass incarceration is a manifestation of racist policy. Companies like Comcast that have the prison industrial complex embedded in their 401(k) plans are forcing their employees to invest in racial injustice. It\u2019s time for employees and society at large to make sure that investments stop funding private prisons and other companies profiting from economic systems of oppression and exploitation.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Start by signing this petition to Comcast\u2019s management saying that it\u2019s time to stop funding the prison industrial complex.'
                    )
                  )
                ),
                _react2.default.createElement(_components.ComcastPetitionLetter, null)
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links visible-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-lbl' },
              'More'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.plans + '/comcast',
                  title: 'Comcast 401(k) scorecard',
                  xstrong: true
                },
                'See the scorecard for the Comcast 401(k)',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenter,
                  title: 'Action center',
                  xstrong: true
                },
                'Action center',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return ComcastPetitionLanding;
}(_react.Component)) || _class);
exports.default = ComcastPetitionLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ComcastPetitionLanding/ComcastPetitionLanding.js
// module id = 1466
// module chunks = 0